import React from 'react';

import Metadata from '@pray/shared/components/Metadata';

import { Hourglass, Microphone, Globus, Pencil } from 'components/pages/public/components/icons/benefits';
import { AudioBook } from 'components/pages/public/components/icons/features';
import { PRODUCT_LABELS, Products } from 'components/pages/public/types/products';
import { VIEW_EVENT_NAMES } from 'constants.js';

import { Header } from '../../../../components/Header/Header';
import ProductPageLayout from '../../layout/ProductPageLayout';

const AudiobookPage: React.FC = () => {
  return (
    <div data-viewname={VIEW_EVENT_NAMES.PRODUCTS.AI_AUDIO_BOOKS}>
      <Metadata
        title={`${PRODUCT_LABELS[Products.AI_AUDIO_BOOKS]}: Books to Your Voice | ${
          PRODUCT_LABELS[Products.PRAYSTUDIO]
        }`}
        description={`Turn books into audiobooks in your voice with ${PRODUCT_LABELS[Products.PRAYSTUDIO]}'s ${
          PRODUCT_LABELS[Products.AI_AUDIO_BOOKS]
        }. Fast, easy, & faithful—grow your reach!`}
      />
      <Header />
      <ProductPageLayout
        // Hero section
        tag={PRODUCT_LABELS[Products.AI_AUDIO_BOOKS]}
        icon={<AudioBook />} // Using AudioBook icon for Hero
        title="Share Your Message Beyond the Page"
        description="Transform your writing into audiobooks—easily, in your personal voice."
        ctaText="GET STARTED"
        heroMedia={{ type: 'image', src: 'https://d339bgihw9yfmi.cloudfront.net/web/images/audiobooks-hero.png' }}
        // Benefits section
        benefitsSectionTitle={`Why ${PRODUCT_LABELS[Products.AI_AUDIO_BOOKS]}?`}
        benefits={[
          {
            icon: <Hourglass />,
            title: 'Save Precious Time',
            description: 'Skip the lengthy and costly studio recording processes.',
            linkText: 'LEARN MORE',
          },
          {
            icon: <Microphone />,
            title: 'Keep a Personal Touch',
            description: 'Keep your voice and tone as the ultimate connection with your readers.',
            linkText: 'LEARN MORE',
          },
          {
            icon: <Globus />,
            title: 'Increase Accessibility',
            description: 'Share the Word of God with a broader audience who rely on audio content.',
            linkText: 'LEARN MORE',
          },
          {
            icon: <Pencil />,
            title: 'Easy Editing',
            description:
              'Quickly make changes and preview your audiobook before finalizing to ensure it sounds just right.',
            linkText: 'LEARN MORE',
          },
        ]}
        // How it works section
        howItWorksSectionTitle="How it Works"
        steps={[
          {
            tag: 'STEP 1',
            title: 'Upload Your Manuscript',
            description: `Simply upload your book into ${PRODUCT_LABELS[Products.PRAYSTUDIO]}.`,
            buttonText: 'GET STARTED',
            imageSrc: 'https://d339bgihw9yfmi.cloudfront.net/web/images/audiobooks-benefit-step-1.png',
            imageAlt: 'Upload your manuscript',
          },
          {
            tag: 'STEP 2',
            title: 'AI Voice Matching',
            description:
              'Our advanced AI uses your voice for a personal and authentic audiobook experience, meaning your listeners will hear your words spoken in your voice.',
            buttonText: 'GET STARTED',
            imageSrc: 'https://d339bgihw9yfmi.cloudfront.net/web/images/audiobooks-benefit-step-2.png',
            imageAlt: 'AI Voice Matching',
          },
          {
            tag: 'STEP 3',
            title: 'Fast Turnaround',
            description:
              'Within minutes, your audiobook is ready to download and share. No long studio hours required!',
            buttonText: 'GET STARTED',
            imageSrc: 'https://d339bgihw9yfmi.cloudfront.net/web/images/audiobooks-benefit-step-3.png',
            imageAlt: 'Fast Turnaround',
          },
        ]}
        // Solution cards section
        solutionsSectionTitle="All-in-one Solution"
      />
    </div>
  );
};

export default AudiobookPage;
